import { ApiEstimationStage } from '@/api/schema/data-contracts';
import { apiEstimationStageMessageDefinitions } from '@/context/localization/enums/messages';
import { useMessages } from '@/hooks/messages';

interface EstimationStageBadgeProps {
  stage: ApiEstimationStage;
  isActive?: boolean; // todo: we need to make sure if we still need the isActive prop and refactor the code
}

export const EstimationStageBadge: FC<EstimationStageBadgeProps> = ({ stage, isActive }) => {
  const messages = useMessages(apiEstimationStageMessageDefinitions);

  switch (stage) {
    case ApiEstimationStage.IN_CREATION:
      return (
        <span
          data-testid={`estimation-stage-badge-${stage}`}
          className={`badge whitespace-nowrap lowercase ${isActive ? 'badge-outline-primary' : 'border-none text-black'}`}
        >
          {messages.IN_CREATION()}
        </span>
      );
    case ApiEstimationStage.IN_PROCESS:
      return (
        <span
          data-testid={`estimation-stage-badge-${stage}`}
          className={`badge whitespace-nowrap lowercase ${isActive ? 'badge-outline-primary' : 'border-none text-black'}`}
        >
          {messages.IN_PROCESS()}
        </span>
      );
    case ApiEstimationStage.IN_REVIEW:
      return (
        <span
          data-testid={`estimation-stage-badge-${stage}`}
          className={`badge whitespace-nowrap lowercase ${isActive ? 'badge-outline-primary' : 'border-none text-black'}`}
        >
          {messages.IN_REVIEW()}
        </span>
      );
    case ApiEstimationStage.APPROVED:
      return (
        <span
          data-testid={`estimation-stage-badge-${stage}`}
          className={`badge bg-badgeOk whitespace-nowrap lowercase ${isActive ? 'badge-outline-primary' : 'border-none text-black'}`}
        >
          {messages.APPROVED()}
        </span>
      );
    default:
      throw new Error('Unsupported stage');
  }
};
